import { render, staticRenderFns } from "./Adesao.vue?vue&type=template&id=402c5a6e&scoped=true&"
import script from "./Adesao.vue?vue&type=script&lang=js&"
export * from "./Adesao.vue?vue&type=script&lang=js&"
import style0 from "./Adesao.vue?vue&type=style&index=0&id=402c5a6e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "402c5a6e",
  null
  
)

export default component.exports